import React from 'react';
import { connect } from 'react-redux';
import { Trans, t } from '@lingui/macro';
import { I18n } from '@lingui/react';
import {
  loadResetPassword,
  resetPassword,
  loadPrepareEncryption,
  forgotPassword,
} from '../../state/action-mess';
import ResetPasswordForm from './ResetPasswordForm';
import ResetPasswordFormInvalid from './ResetPasswordFormInvalid';
import styles from './style.css';
import ConfirmPasswordModal from '../ConfirmPasswordModal';

class ResetPassword extends React.Component {
  componentDidMount() {
    const resetPasswordToken = this.props.params.token;
    this.props.dispatch(loadResetPassword(resetPasswordToken));
    this.props.dispatch(loadPrepareEncryption());
  }

  constructor(props) {
    super(props);
    this.state = {
      showConfirmUpdateModal: false,
    };
  }

  render() {
    const { dispatch, data } = this.props;
    const resetState = data.moka.resetPasswordState;
    return (
      <div className="container">
        <div className="row">
          <div className={styles.root} id="reset-password-page">
            {resetState.tokenError ? (
              <div>
                <h3 className={styles['title-panel']}>
                  <Trans>Link Expired :(</Trans>
                </h3>

                <I18n>
                  {({ i18n }) => (
                    <ResetPasswordFormInvalid
                      dispatch={dispatch}
                      history={this.props.history}
                      onSubmit={this.sendForgotPassword}
                      btnText={i18n._(t`Submit`)}
                    />
                  )}
                </I18n>
              </div>
            ) : (
              <div>
                <h3 className={styles['title-panel']}>
                  <Trans>Choose a new password</Trans>
                </h3>

                <I18n>
                  {({ i18n }) => (
                    <ResetPasswordForm
                      dispatch={dispatch}
                      fullName={resetState.fullName}
                      history={this.props.history}
                      onSubmit={this.handleSubmit}
                      btnText={i18n._(t`Save new password`)}
                    />
                  )}
                </I18n>
              </div>
            )}
          </div>
        </div>
        <ConfirmPasswordModal
          onConfirm={this.handleSubmit}
          close={this._closeConfirmModal}
          show={this.state.showConfirmModal}
        />
      </div>
    );
  }

  /**
   * Handle submission of login form
   * @param values the JSON containing {email,password}
   */

  sendForgotPassword = values => {
    const { email } = values;
    this.props.dispatch(forgotPassword({ email }));
  };

  _onClickReset = () => {
    this.setState({
      showConfirmModal: true,
    });
  };

  handleSubmit = () => {
    const { values } = this.props.data.form.ResetPasswordForm;
    const resetPasswordToken = this.props.params.token;
    this.props.dispatch(resetPassword(values, resetPasswordToken));
    this.setState({
      showConfirmModal: false,
    });
  };

  _closeConfirmModal = () => {
    this.setState({
      showConfirmModal: false,
    });
  };
}

// Which props do we want to inject, given the global state?
function select(state) {
  return {
    data: state,
  };
}

// Wrap the component to inject dispatch and state into it
export default connect(select)(ResetPassword);
